export default function PageHero({ eyebrow, title, subtitle, italic }) {
  return (
    <section className="bg-[#A3133A] text-[#FBFBF9] relative overflow-hidden grain" data-testid="page-hero">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-24 py-24 sm:py-32 relative z-10">
        {eyebrow && <div className="text-[11px] tracking-eyebrow opacity-80 mb-6 fade-up">{eyebrow}</div>}
        <h1 className="font-serif-display text-5xl sm:text-7xl leading-[0.95] tracking-tight max-w-4xl fade-up fade-up-delay-1">
          {title} {italic && <em className="italic font-light">{italic}</em>}
        </h1>
        {subtitle && <p className="mt-8 text-lg max-w-2xl opacity-90 leading-relaxed fade-up fade-up-delay-2">{subtitle}</p>}
      </div>
    </section>
  );
}
